/**
 * Created by Ning Jiang on 1/14/2020.
 */

import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {IReelStoppedData} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {ReelStopPresentationController} from "@nolimitcity/slot-game/bin/core/reelstoppresentation/ReelStopPresentationController";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {Timeline, TimelineLite} from "gsap";
import {DWBackground} from "../../background/DWBackground";
import {DeadwoodGameConfig} from "../../DeadwoodGameConfig";
import {DeadwoodSoundConfig} from "../../DeadwoodSoundConfig";
import {DeadwoodReelView} from "../../reel/DeadwoodReelView";
import {DeadwoodParsedGameData} from "../../server/data/DeadwoodParsedGameData";
import {DeadwoodBonusSymbol} from "../../symbols/DeadwoodBonusSymbol";
import {DeadwoodReelSymbol} from "../../symbols/DeadwoodReelSymbol";

export class DeadwoodBonusAttentionController extends ReelStopPresentationController {

    private _bonusPositions:number[];
    private _bonusTriggered:boolean;
    private _fsSuperModeActive:boolean;
    private _mode:string;
    private _freespinsLeft:number;
    private _isLooping:boolean;

    constructor(index:number) {
        super(index, "BonusAttention");
    }

    protected parseFeatureGameData(data:DeadwoodParsedGameData):void {
        this._bonusTriggered = data.bonusTriggeredThisSpin;
        this._bonusPositions = data.bonusPositions;
        this._fsSuperModeActive = data.fsSuperModeActive;
        this._mode = data.mode;
        this._freespinsLeft = data.freespinsLeft;
    }

    public onReelBounce(data:IReelStoppedData):void {
        // both B stuck.
        if(this._fsSuperModeActive && !this._bonusTriggered) {
            return this.dispatchCompleteEvent(data.reelId);
        }

        if(data.reelId === 0 && this._bonusPositions [0] > -1) {
            if(data.quickStop && this.isMainGame()) {
                return this.dispatchCompleteEvent(data.reelId); // do not play attention on first B if quick stop in main game.
            }

            const firstTimeline:TimelineLite = new TimelineLite();
            firstTimeline.add([
                () => SlotGame.sound.playEffect(DeadwoodSoundConfig.instance.START_LANDING_1),
                this.playBonusSymbolAttention(0, true, !this.isMainGame())
            ]);
            firstTimeline.add(() => this.dispatchCompleteEvent(data.reelId));
            return;
        }

        if(data.reelId === 4) {
            this._isLooping = false;

            if(this._bonusPositions[4] === -1) {
                return this.dispatchCompleteEvent(data.reelId);
            }

            if(this._bonusTriggered) {
                const timeline:TimelineLite = new TimelineLite();
                timeline.add(() => {
                    SlotGame.sound.playEffect(this._fsSuperModeActive ? DeadwoodSoundConfig.instance.START_LANDING_2_SUPER : DeadwoodSoundConfig.instance.START_LANDING_2);
                    (<DeadwoodReelView>Reels.getReel(0)!.view).addSymbolToWinContainer(Reels.getSymbol(0, this._bonusPositions[0])!);
                    (<DeadwoodReelView>Reels.getReel(4)!.view).addSymbolToWinContainer(Reels.getSymbol(4, this._bonusPositions[4])!);
                }, 0);
                timeline.add(this.playBonusSymbolAttention(0, false, false), 0);
                timeline.add(this.playBonusSymbolAttention(4, false, !this.isMainGame()), 0);
                timeline.add(() => {
                    for(let i:number = 1; i < 4; i++) {
                        for(let j:number = 0; j < 4; j++) {
                            const symbol:DeadwoodReelSymbol = <DeadwoodReelSymbol>Reels.getSymbol(i, j);
                            if(!symbol) {
                                continue;
                            }
                            if(symbol.symName.includes("L")) {
                                symbol.burnBonus(false, false);
                            }
                        }
                    }
                    this.dispatchCompleteEvent(data.reelId);
                });
                timeline.play();
                return;
            }

            if(this.isMainGame()) {
                return this.dispatchCompleteEvent(data.reelId);
            }

            // play +1 fs in fs modes.
            const lastRetriggerTimeline:TimelineLite = new TimelineLite();
            lastRetriggerTimeline.add([
                () => SlotGame.sound.playEffect(DeadwoodSoundConfig.instance.START_LANDING_2),
                this.playBonusSymbolAttention(4, false, true)
            ]);
            lastRetriggerTimeline.add(() => this.dispatchCompleteEvent(data.reelId));
            return;
        }

        return this.dispatchCompleteEvent(data.reelId);
    }

    private playBonusSymbolAttention(reelId:number, loop:boolean, retrigger:boolean):Timeline {
        this._isLooping = loop;
        const symbol:DeadwoodBonusSymbol | null = <DeadwoodBonusSymbol>Reels.getSymbol(reelId, this._bonusPositions[reelId]);
        if(symbol == null) {
            debugger;
            throw new Error(`DeadwoodBonusAttentionController.playBonusSymbolAttention(): Cannot find symbol at reelId = ${reelId}, symbolId = ${this._bonusPositions[reelId]}`);
        }

        const reelView:PIXI.Container = Reels.getReel(reelId)!.view;
        reelView.parent.addChild(reelView);
        symbol.parent.addChild(symbol);


        const timeline:TimelineLite = new TimelineLite();
        timeline.add(symbol.changeState({
            state : DeadwoodGameConfig.instance.SYMBOL_STATES.landing,
            replay : true,
            fadeInDuration : 0.5,
            onCompleteCallback : () => {
                if(retrigger) {
                    if(reelId === 0 && this._fsSuperModeActive) {
                        SlotGame.keypad.setZeroBetSpinCounter(this._freespinsLeft - 1);
                    } else {
                        SlotGame.keypad.setZeroBetSpinCounter(this._freespinsLeft);
                    }
                }

                if(this._isLooping) {
                    this.playBonusSymbolAttention(reelId, true, false);
                    return;
                }

                // no looping
                if(this._bonusTriggered) {
                    symbol.changeState({
                        state : GameConfig.instance.SYMBOL_STATES.win
                    });
                    return;
                }

                symbol.changeState({
                    state : GameConfig.instance.SYMBOL_STATES.normal
                });

            }
        })!, 0);
        if(retrigger) {
            timeline.add(symbol.getRetriggerTimeline(), 0.05);
        }

        return timeline;
    }

    private isMainGame():boolean {
        return this._mode === GameMode.NORMAL;
    }
}